import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLanguage } from "@/i18n/LanguageContext";
import { FadeIn } from "@/hooks/use-scroll-animation";

const faqsFi = [
  {
    q: "Kuinka kauan kaihtimien asennus kestää?",
    a: "Tavallinen kaihdin- tai rullaverhoasennus kestää noin 1–3 tuntia riippuen ikkunoiden määrästä ja asennuskohteen vaativuudesta. Suuremmissa projekteissa, kuten koko talon kaihtimien asennuksessa, varaa aikaa puoli päivää.",
  },
  {
    q: "Asennatteko kaikkiin ikkunatyyppeihin?",
    a: "Kyllä, asennamme kaihtimet, rullaverhot, lamelliverhot ja parvekkeiden kaihtimet lähes kaikkiin ikkunatyyppeihin – myös erikoismalleihin, kulmaikkunoihin ja kattoluukkuihin. Käymme tarvittaessa mittaamassa kohteen etukäteen.",
  },
  {
    q: "Millä alueilla toimitte?",
    a: "Palvelemme koko Keski-Uudenmaan alueella: Hyvinkää, Järvenpää, Kerava, Mäntsälä, Nurmijärvi, Pornainen ja Tuusula. Koko pääkaupunkiseutu. Tarvittaessa myös lähialueet sopimuksen mukaan.",
  },
  {
    q: "Mitä kaihtimien asennus maksaa?",
    a: "Asennuksen hinta riippuu tuotteesta, ikkunoiden koosta ja määrästä. Pyydä ilmainen arvio ottamalla meihin yhteyttä – annamme aina selkeän hinnan ennen työn aloitusta.",
  },
  {
    q: "Täytyykö minun tilata tuotteet itse?",
    a: "Ei tarvitse! Toimimme Solar Kaihtimen ja Osion virallisena jälleenmyyjänä ja hoidamme tuotteiden tilauksen puolestasi. Voit tutustua valikoimiin osoitteissa solar.fi ja osio.fi.",
  },
  {
    q: "Tarjoatteko takuun asennukselle?",
    a: "Kyllä. Asennustyö tehdään aina ammattitaidolla ja tuotteilla on valmistajan takuu. Mikäli asennuksessa ilmenee ongelmia, korjaamme ne veloituksetta.",
  },
];

const faqsEn = [
  {
    q: "How long does blind installation take?",
    a: "A standard blind or roller blind installation takes about 1–3 hours depending on the number of windows and complexity. For larger projects like a whole-house installation, allow half a day.",
  },
  {
    q: "Do you install on all window types?",
    a: "Yes, we install blinds, roller blinds, vertical blinds and balcony blinds on almost all window types – including special models, corner windows and skylights. We can visit for measuring beforehand if needed.",
  },
  {
    q: "Which areas do you serve?",
    a: "We serve the entire Central Uusimaa region: Hyvinkää, Järvenpää, Kerava, Mäntsälä, Nurmijärvi, Pornainen and Tuusula. The entire Helsinki metropolitan area. Nearby areas also available by arrangement.",
  },
  {
    q: "How much does blind installation cost?",
    a: "The price depends on the product, window size and quantity. Request a free estimate by contacting us – we always provide a clear price before starting work.",
  },
  {
    q: "Do I need to order the products myself?",
    a: "No! We are an official reseller of Solar Kaihdin and Osio and handle the product ordering for you. You can browse the ranges at solar.fi and osio.fi.",
  },
  {
    q: "Do you offer a warranty on installation?",
    a: "Yes. All installation work is done professionally and products come with a manufacturer's warranty. If any issues arise with the installation, we'll fix them free of charge.",
  },
];

const FAQ = () => {
  const lang = useLanguage();
  const faqs = lang === "en" ? faqsEn : faqsFi;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id={lang === "en" ? "faq" : "ukk"} className="py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <div className="container max-w-3xl">
        <FadeIn>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-10">
            {lang === "en" ? "Frequently asked questions" : "Usein kysytyt kysymykset"}
          </h2>
        </FadeIn>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <FadeIn key={i} delay={i * 75}>
              <AccordionItem value={`faq-${i}`} className="bg-card rounded-lg border px-5">
                <AccordionTrigger className="text-left font-medium text-sm md:text-base">{f.q}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            </FadeIn>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
